//import constants.js here
import {constants} from './constants';
import {debugConstants} from './debug-constants';

//set the constants data array
let constantsData = constants;

// STARTING VARIABLES

let launched = false;
// height h0
let height = 0;
// speed v0
let speed = 0;
// m (mass of rocket + fuel)
let mass = 0;
// maximum height
let maxHeight = 0;
// maximum speed
let maxSpeed = 0;
// tmax (time to reach max height)
let tMax = 0;
// whether the rocket has exploded
let explodes = false;
// whether the thruster is on or off.
let thruster = false;
let time = 0.0;

export default function (event, inputs, playSpeed) {

  // check if we are using the debug constants or the real ones.
  if ($('#use-debug').is(":checked")) {
    constantsData = debugConstants;
  } else {
    constantsData = constants;
  }

    // has the simulation ended
  let ended = false;
  // DEFINITIONS
  // T
  let thrust = parseInt(inputs.thrust);
  // tT
  let thrustTime = parseInt(inputs.thrust_time);
  // inputs? m0
  let massAtStart = parseInt(inputs.mass);
  // D (drag in N)
  let drag = 0;
  // Cd (coefficient of drag)
  let coefficientOfDrag = constantsData.coefficientOfDrag;
  // p (air density - 1.2kg/m2 at sea level)
  let airDensity;
  // diameter (diameter of rocket (m))
  let diameter = constantsData.diameter;
  // A
  let crossSectionalAreaOfRocket;
  // F - resultant force acting on rocket
  let resultantForceActingOnRocket;
  // W - weight force
  let weightForce;
  // a - acceleration (F/m)
  let acceleration;
  // fuel f0
  let fuel = 0;
  // fuel constant for calculating the fuel mass burned at every tick
  let fuelConst = constantsData.fuelConstant;
  // time t0
  let timeDelta = event.delta / 1000 * playSpeed;
  // direction
  let direction = 'up';
  // gravity
  let gravity;


  //initialise mass when the simulation begins.
  if (mass == 0) {
    mass = massAtStart;
  }



  //update time
  time += timeDelta;

  // calculate values needed for force and drag calculations.
  crossSectionalAreaOfRocket = 3.14 * ((diameter / 2) ** 2);
  airDensity = constantsData.airDensity * ((0.5) ** (height / 5500));
  gravity = constantsData.gravity * (0.25 ** (height / 6300000));

  // THRUSTER
  if (time >= thrustTime) {
    thruster = false;
    thrust = 0;
  } else {
    thruster = true;
  }

  // mass change - using fuel during thrust
  if (inputs.mass_change) {
    // if thruster is running, calculate change in mass of fuel.
    if (thruster) {
      fuel = (fuelConst * thrust * timeDelta);
    }
  } else {
    fuel = 0;
  }

  // Drag
  if (inputs.drag) {
    if (direction == 'up') {
      drag = -1 * (coefficientOfDrag * crossSectionalAreaOfRocket
          * (0.5 * airDensity * (speed ** 2)));
    } else {
      drag = coefficientOfDrag * crossSectionalAreaOfRocket
          * (0.5 * airDensity * (speed ** 2));
    }
  } else {
    drag = 0;
  }

  //calculate change in mass after some fuel is burned off in this tick
  mass = mass - fuel;
  //calculate the forces acting of the rocket (weight, thrust and drag),
  // and use it to work out the acceleration
  weightForce = -1 * (mass * gravity);
  resultantForceActingOnRocket = thrust + weightForce + drag;
  acceleration = resultantForceActingOnRocket / mass;

  // use distance formula to work out the new height of the rocket, and find the height change.
  let newHeight = height + ((speed * timeDelta) + (0.5 * acceleration
      * (timeDelta ** 2)));

  let heightChange = newHeight - height;

  // check if rocket is still moving up.
  if (heightChange < 0) {
    direction = 'down';
  }

  // update the max height and current time of flight
  if (newHeight > height) {
    maxHeight = newHeight;
    tMax = time;
  }

  // check if simulation over if the rocket is falling down.
  if (direction == 'down') {
    // newHeight = 0;
    if (!thruster && maxHeight< constantsData.payloadHeight) {
      ended = true;
    }
  }



  height = newHeight;
  // calculate the speed of the rocket and speed change.
  let newSpeed = speed + (acceleration * timeDelta);
  if (newSpeed > speed) {
    maxSpeed = newSpeed;
  }

  let speedChange = newSpeed - speed;

  speed = newSpeed;

  if(!launched&& thrustTime==0||(weightForce-thrust<0&&height<=0)){
    launched=false;
    ended=true;
  }else{
    launched=true;
  }

  // EXPLOSION logic
  if (thrust - drag >= constantsData.stressCoefficient * mass * gravity) {
    explodes = true;
    if (thrust >= constantsData.stressCoefficient * massAtStart * gravity) {
      launched = false;
    }
  }
  // if the rocket has exploded, then the simulation has ended.
  if (explodes||thrustTime==0) {
    ended = true;
  }


  return {
    weightForce: weightForce,
    mass: mass,
    thrust: thrust,
    resultantForceActingOnRocket: resultantForceActingOnRocket,
    height: height,
    heightChange: heightChange,
    speed: speed,
    speedChange: speedChange,
    drag: drag,
    acceleration: acceleration,
    time: time,
    realTime: event.time,
    timeChange: event.delta * playSpeed,
    launched: launched,
    thruster: thruster,
    direction: direction,
    explodes: explodes,
    maxHeight: maxHeight,
    maxSpeed: maxSpeed,
    timeToMaxHeight: tMax,
    ended: ended,
  };
}

export function reset() {
  // reset initial values to rerun simulator
  launched = false;
  height = 0;
  speed = 0;
  mass = 0;
  maxHeight = 0;
  maxSpeed = 0;
  tMax = 0;
  explodes = false;
  thruster = false;
  time = 0.0;
}
